export default "__VITE_PUBLIC_ASSET__2dccbfd4__"